import { VFlow } from 'bold-ui'
import { useMedicoesAtendimentosAnterioresQuery } from 'graphql/hooks.generated'
import { AtendimentoProfissional } from 'graphql/types.generated'
import { isEmpty, orderBy } from 'lodash'
import React from 'react'
import { convertMedicaoOutrosAtendimentos } from 'view/atendimentos/detail/components/modals/medicoes/converter-medicoes'
import { MedicoesPreNatalTable } from 'view/atendimentos/detail/components/modals/medicoes/pre-natal/MedicoesPreNatalTable'
import { getMedicoesAntropometricasPreNatal } from 'view/atendimentos/detail/components/modals/medicoes/pre-natal/util-medicoesPreNatal'
import { convertMedicoesUltimaGestacao } from 'view/atendimentos/detail/soap/aside/pre-natal/converter-acompanhamentoPreNatal'

interface MedicoesGestacaoTabContentProps {
  prontuarioId: ID
  dataInicioGestacao: Date
  atendimentosProfUltimaGestacao: AtendimentoProfissional[]
  isDataInicioGestacaoEcografica: boolean
  loading?: boolean
}

export const MedicoesGestacaoTabContent = (props: MedicoesGestacaoTabContentProps) => {
  const {
    prontuarioId,
    dataInicioGestacao,
    atendimentosProfUltimaGestacao,
    isDataInicioGestacaoEcografica,
    loading,
  } = props

  const {
    data: { medicoes },
    loading: loadingMedicoes,
  } = useMedicoesAtendimentosAnterioresQuery({
    variables: { prontuarioId },
    fetchPolicy: 'cache-first',
  })

  const medicoesAntropometricasPreNatal =
    medicoes &&
    getMedicoesAntropometricasPreNatal([
      ...[...medicoes].sort((a, b) => b.dataMedicao - a.dataMedicao).map(convertMedicaoOutrosAtendimentos),
    ])

  const medicoesPreNatal = atendimentosProfUltimaGestacao?.map((atendProf, index) => {
    const medicao = !isEmpty(atendProf.medicoes) ? atendProf.medicoes[0] : null
    const dataMedicao = medicao?.dataMedicao ?? atendProf.iniciadoEm
    return convertMedicoesUltimaGestacao(index, medicao, atendProf.atendimentoProfissionalPreNatal, dataMedicao)
  })

  return (
    <VFlow>
      <MedicoesPreNatalTable
        dataInicioGestacao={dataInicioGestacao}
        medicoesAntropometricasPreNatal={medicoesAntropometricasPreNatal}
        isIgEcografica={isDataInicioGestacaoEcografica}
        items={orderBy(medicoesPreNatal, 'numeroConsulta', 'desc')}
        loading={loading || loadingMedicoes}
        showPressaoArterial
      />
    </VFlow>
  )
}
